import React, { Component } from 'react'
import { Divider } from '@mui/material'

export class JsonFormDivider extends Component {
    render() {
        return <Divider sx={{ margin: '30px 0' }} />
    }
}

export default JsonFormDivider
